module.exports = __webpack_public_path__ + "img/client-logo2.f3c22d23.png";